import React, { useState } from 'react';

const defaultFaqs = [
  {
    question: "What is Mokshiq and what services does it offer?",
    answer: "Mokshiq, a product of Rakle Service Private Limited, is a comprehensive B2B Fintech platform offering AEPS, Direct Money Transfer (DMT), BBPS Bill Payments, Prepaid Mobile & DTH Recharge APIs, Micro ATM SDKs, and Instant Identity & Document Verification APIs (Verify)."
  },
  {
    question: "How can I integrate Mokshiq Verification APIs (Verify)?",
    answer: "Our Verification APIs offer seamless RESTful integration with full developer documentation, sandbox keys, and real-time SDKs for Bank Account Penny Drop, PAN Card, Aadhaar OTP/XML, GSTIN, UPI VPA, and Vehicle RC verification."
  },
  {
    question: "What is the uptime SLA for Recharge and AEPS APIs?",
    answer: "We guarantee a 99.9% uptime SLA powered by intelligent multi-operator LAPU routing, multi-bank switchers, and instant automated refund callbacks for any failed transactions."
  },
  {
    question: "Who can become a Mokshiq Partner or Distributor?",
    answer: "Any retailer, distributor, master distributor, fintech startup, or corporate enterprise can sign up for our White-Label Solutions or B2B Partner Portal to start offering banking and bill payment services."
  },
  {
    question: "How do I reach Mokshiq Support or Sales?",
    answer: "You can reach out to our Sales team at sales@mokshiq.in or call +91 7311104571. For support, email support@mokshiq.in or visit our corporate office at 1st Floor, C 78, Sector-2, Noida."
  }
];

function FAQ({ 
  faqList,
  faqs, 
  title = "Everything You Need to Know About Mokshiq", 
  subtitle = "Find instant answers to common questions about our platform and services.",
  badgeText = "FREQUENTLY ASKED QUESTIONS",
  isDark = true
}) {
  const [activeIndex, setActiveIndex] = useState(0);

  // Normalize FAQ items array from any prop name
  const items = faqList || faqs || defaultFaqs;

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className={`faq_section py-5 ${isDark ? 'bg-dark-emerald' : 'bg-light'}`} style={{ minHeight: '400px' }}>
      <div className="container py-4">
        
        {/* Header Unit */}
        <div className="text-center mb-5 pt-2">
          <div 
            className="d-inline-block px-4 py-2 rounded-pill mb-3 border shadow-sm" 
            style={{ 
              backgroundColor: isDark ? 'rgba(204, 255, 0, 0.15)' : '#e2e8f0', 
              color: isDark ? '#ccff00' : '#334155', 
              borderColor: isDark ? 'rgba(204, 255, 0, 0.4)' : '#cbd5e1',
              fontSize: '0.85rem', 
              fontWeight: '700',
              letterSpacing: '1px'
            }}
          >
            {badgeText}
          </div>
          
          <h2 className={`heading_text font-weight-bold display-6 mb-3 ${isDark ? 'text-white' : 'text-dark'}`}>
            {title}
          </h2>
          
          {subtitle && (
            <p className={`mx-auto mb-0 ${isDark ? 'text-white-50' : 'text-muted'}`} style={{ maxWidth: '680px', fontSize: '1rem', lineHeight: '1.6' }}>
              {subtitle}
            </p>
          )}
        </div>

        {/* FAQ Accordion List */}
        <div className="row justify-content-center">
          <div className="col-lg-9 col-xl-8">
            <div className="d-flex flex-column gap-3">
              {items && items.map((faq, index) => {
                const isOpen = activeIndex === index;
                const questionText = faq.question || faq.q || faq.title || `Question ${index + 1}`;
                const answerText = faq.answer || faq.a || faq.desc || "Answer details coming soon.";

                return (
                  <div 
                    key={index} 
                    className="rounded-4 border shadow-sm overflow-hidden"
                    style={{ 
                      backgroundColor: isDark ? '#043836' : '#ffffff',
                      borderColor: isOpen ? '#ccff00' : (isDark ? 'rgba(204, 255, 0, 0.2)' : '#e2e8f0'), 
                      boxShadow: isOpen ? '0 8px 25px rgba(204, 255, 0, 0.2)' : '0 2px 8px rgba(0,0,0,0.04)',
                      transition: 'all 0.25s ease' 
                    }}
                  >
                    <button 
                      className="w-100 text-start d-flex justify-content-between align-items-center p-4 border-0 bg-transparent"
                      type="button" 
                      onClick={() => toggleAccordion(index)}
                      style={{ cursor: 'pointer', outline: 'none' }}
                    >
                      <span className="font-weight-bold pe-3 d-flex align-items-center" style={{ fontSize: '1.02rem', color: isDark ? '#ffffff' : '#0f172a', lineHeight: '1.5' }}>
                        <span className="me-3 fw-bold flex-shrink-0" style={{ color: '#ccff00', fontSize: '1.1rem' }}>{`Q${index + 1}.`}</span>
                        <span>{questionText}</span>
                      </span>
                      
                      {/* Chevron Arrow Icon */}
                      <span className="ms-2 transition-transform d-inline-flex align-items-center justify-content-center flex-shrink-0" style={{ width: '32px', height: '32px', backgroundColor: isDark ? 'rgba(204, 255, 0, 0.12)' : '#f1f5f9', borderRadius: '50%' }}>
                        <i 
                          className={`fa-solid ${isOpen ? 'fa-chevron-up' : 'fa-chevron-down'}`} 
                          style={{ 
                            fontSize: '13px', 
                            color: isOpen ? '#ccff00' : (isDark ? '#ccff00' : '#64748b'),
                            transition: 'transform 0.2s ease' 
                          }}
                        ></i>
                      </span>
                    </button>
                    
                    {isOpen && (
                      <div className="px-4 pb-4 pt-2" style={{ color: isDark ? 'rgba(255, 255, 255, 0.85)' : '#334155', fontSize: '0.96rem', lineHeight: '1.7', borderTop: isDark ? '1px solid rgba(204, 255, 0, 0.15)' : '1px solid #f1f5f9' }}>
                        {answerText}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}

export default FAQ;
